import React from "react";

const SearchBar = ({ value, onChange }) => {

return (
    <div className="relative ml-2">
      <input
        type="text"
        placeholder="Buscar cursos..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-[320px] px-4 py-2 rounded-full border border-gray-300 focus:outline-none 
                   focus:ring-2 focus:ring-yellow-500 transition"
      />

      {/* Ícone */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="2"
        stroke="currentColor"
        className="w-5 h-5 absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 21l-4.35-4.35m1.23-5.4a6.63 6.63 0 11-13.26 0 6.63 6.63 0 0113.26 0z"
        />
      </svg>
    </div>
  );
};

export default SearchBar;
